import * as React from 'react';
import { times } from 'lodash';

import {
	Wrapper,
	Title,
	Value,
	Header,
	HeaderLabel,
	ColName,
	ColValue,
	TotalColValue,
	OthersColValue,
	Row,
	Box,
	List,
} from './styles';

export const ListBox = props => {
	const {
		total,
		colors,
		colsPerRow,
		data,
		isTopItem,
		selectedCompanies,
		renderContextualMenu,
		parentName,
	} = props;

	const companiesLength = selectedCompanies.length;

	return (
		<Wrapper>
			<Box isTopItem={isTopItem}>
				<Title>{total.name}</Title>
				<Value>{total.value}</Value>
			</Box>

			{data && (
				<List>
					<Header>
						<ColName companiesLength={companiesLength} />
						<TotalColValue>Total</TotalColValue>
						{data[0].values.length > 2 && (
							times(companiesLength, index => (
								<ColValue colsPerRow={colsPerRow} key={index + colors[index]}>
									<HeaderLabel style={{ background: colors[index] }} />
								</ColValue>
							))	
						)}
						{data[0].values.length > 2 && (
							<OthersColValue>Others</OthersColValue>
						)}
					</Header>

					{data.map((dataItem, index) => (
						<Row key={index}>
							{renderContextualMenu &&
								renderContextualMenu(dataItem, index, parentName)}

							<ColName companiesLength={companiesLength} title={dataItem.name}>
								{dataItem.name}
							</ColName>
							{dataItem.values.map((value, index) => (
								<ColValue key={index + value}>{value}</ColValue>
							))}
						</Row>
					))}
				</List>
			)}
		</Wrapper>
	);
};
